
import Button from '~/components/detail/Button.vue'
export default {
  components: {
    Button
  },
  props: {
    result: {
      // 交易商数据
      type: Object,
      default: () => {}
    },
    type: {
      // 企业类型-服务商1，交易商2
      type: Number,
      default: 2
    },
    state: {
      // loading-加载状态;success-成功;error-失败；await-等待审核
      type: String,
      default: 'error'
    },
    awaitp1: {
      // 审核中-文本1
      type: String,
      default: '已提交资料，认证中'
    },
    awaitp2: {
      // 审核中-文本2
      type: String,
      default: 'WikiFX官方人员会在2小时内，审核您提交的资料。'
    },
    successp: {
      // 审核成功文本
      type: String,
      default: '恭喜您，认证成功'
    },
    successtext: {
      // 审核成功按钮文本
      type: String,
      default: '管理企业'
    },
    errorp1: {
      // 审核失败-文本1
      type: String,
      default: '审核资料不通过'
    },
    errorp2: {
      // 审核失败-文本2
      type: String,
      default: '后台选择未通过理由'
    },
    errortext: {
      // 审核失败按钮文本
      type: String,
      default: '再次验证'
    },
    successbt: {
      // 认证成功查看企业
      type: Boolean,
      default: false
    },
    heshow: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      awaitshow: '1'
    }
  },
  methods: {
    lookcompany() {
      // 重新提交
      this.$emit('lookcompany')
    },
    awaitfn() {
      // 稍后提交
      this.$emit('awaitfn')
    },
    tocompany() {
      // 查看企业
      this.$emit('tocompany')
    },
    tohome() {},
    tokefufn() {
      this.$emit('tokefufn')
    },
    setawaitshow(v) {
      this.awaitshow = v
    },
    backapp() {
      // (window).Communication('backApp', JSON.stringify(true))
      this.$emit('close')
    },
    backhome() {
      window.open(`https://www.${this.$store.state.newhost}.${this.getSuffix(this.$store.state)}/${this.$store.state.LanguageCode}/`)
    }
  }
}
